<template>
  <div v-if="rerenderComponent">
    <form-wizard
      :start-index="currentStep"
      @on-complete="submitForm"
      @on-change="handleChangeStep"
      next-button-text="بعدی"
      back-button-text="قبلی"
      :finish-button-text="title"
      shape="tab"
      color="#556ee6"
    >
      <tab-content :before-change="validateAsync" title="مشخصات کلی">
        <ValidationObserver ref="step0" tag="div">
          <form class="needs-validation">
            <div class="row px-0">
              <div class="col-12 px-0">
                <div class="card px-0">
                  <div class="card-body">
                    <h6 class="text-danger" v-if="id !== undefined">
                      در صورت ویرایش کمپین، نیاز به تایید مجدد کمپین توسط مدیر
                      سایت است.
                    </h6>
                    <div class="row mt-4">
                      <div class="col-12">
                        <validation-select
                          class="mt-4"
                          :options="kindOptions"
                          v-model="form.tablighKindId"
                          validation-field-name="نوع کمپین"
                          option-value-key="id"
                          rules="required"
                          option-text-key="name"
                          label="نوع کمپین"
                        >
                        </validation-select>
                      </div>
                      <template v-if="form.tablighKindId.id == 3">
                        <div class="col-md-6">
                          <validation-input
                            v-model="form.androidPkgName"
                            type="text"
                            placeholder="نام پکیج اندروید"
                            rules="required|regex:^[a-z][a-z0-9_]*(\.[a-z0-9_]+)+[0-9a-z_]$"
                            validation-field-name="نام پکیج اندروید"
                            label="نام پکیج اندروید"
                          ></validation-input>
                        </div>
                        <div class="col-md-6">
                          <validation-input
                            v-model="form.iosPkgName"
                            type="text"
                            placeholder="نام پکیج IOS"
                            rules="regex:^[a-z][a-z0-9_]*(\.[a-z0-9_]+)+[0-9a-z_]$"
                            validation-field-name="نام پکیج IOS"
                            label="نام پکیج IOS"
                          ></validation-input>
                        </div>
                      </template>
                      <div class="col-md-6">
                        <validation-input
                          v-model="form.name"
                          type="text"
                          placeholder="عنوان"
                          rules="required|max:190"
                          validation-field-name="عنوان"
                          label="عنوان"
                        ></validation-input>
                      </div>
                      <div class="col-md-6">
                        <validation-input
                          v-model="form.btnText"
                          type="text"
                          placeholder="متن دکمه پایانی"
                          rules="required"
                          validation-field-name="متن دکمه پایانی"
                          label="متن دکمه پایانی"
                        ></validation-input>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <validation-input
                          v-model="form.description"
                          type="text"
                          placeholder="توضیحات کوتاه"
                          rules="required|max:190"
                          validation-field-name="توضیحات کوتاه"
                          label="توضیحات کوتاه"
                        ></validation-input>
                      </div>
                      <div class="col-12 mt-4">
                        <validation-image-cropper-upload
                          rules="required"
                          validation-field-name="آیکن"
                          label="آیکن"
                          v-model="form.picAdd"
                        ></validation-image-cropper-upload>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </tab-content>
      <tab-content :before-change="validateAsync" title="تنظیمات کمپین">
        <ValidationObserver ref="step1" tag="div">
          <form class="needs-validation">
            <div class="row px-0">
              <div class="col-12 px-0">
                <div class="card px-0">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                        <div
                          class="d-flex justify-content-between align-items-center mt-4"
                        >
                          <label>فقط در اپلیکیشن های خودم نمایش بده</label>
                          <switches
                            v-model="form.justMine"
                            type-bold="true"
                            class="mb-0"
                            color="green"
                          ></switches>
                        </div>
                      </div>
                      <div class="col-12 mt-4">
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <label>امکان رد کردن تبلیغ</label>
                          <switches
                            v-model="form.canSkip"
                            type-bold="true"
                            class="mb-0"
                            color="green"
                          ></switches>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="col-md-12">
                        <validation-range-slider
                          :marks="true"
                          :data="versionNames"
                          v-model="form.androidVersionName"
                          label="نسخه API نمایش دهنده گان"
                          validation-field-name="نسخه API"
                          rules="required"
                        ></validation-range-slider>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </tab-content>

      <tab-content :before-change="validateAsync" title="هزینه و بودجه">
        <ValidationObserver ref="step2" tag="div">
          <form class="needs-validation">
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-12">
                        <validation-range-slider
                          v-if="form.tablighKindId !== null"
                          tooltip="تومان"
                          :min="
                            form.tablighKindId.hazine
                              ? form.tablighKindId.hazine
                              : 100
                          "
                          :max="3000"
                          v-model="form.hazine"
                          :label="
                            form.tablighKindId.id == 1
                              ? 'هزینه تبلیغ به تومان (به ازای هر نمایش) '
                              : form.tablighKindId.id == 2
                              ? 'هزینه تبلیغ به تومان (به ازای هر کلیک)'
                              : 'هزینه تبلیغ به تومان (به ازای هر نصب)'
                          "
                          validation-field-name="هزینه تبلیغ"
                          :rules="
                            `required|min_value:${form.tablighKindId.hazine}`
                          "
                        ></validation-range-slider>
                      </div>
                      <div class="col-md-6">
                        <validation-input
                          v-model="form.dailybudget"
                          type="text"
                          placeholder="بودجه روزانه (تومان)"
                          rules="required|numeric"
                          validation-field-name="بودجه روزانه"
                          label="بودجه روزانه"
                        ></validation-input>
                      </div>
                      <div class="col-md-6">
                        <validation-input
                          v-model="form.totalBudget"
                          type="text"
                          placeholder="بودجه کل (تومان)"
                          :rules="
                            `required|numeric|min_value:${campaign_min_total_budget}`
                          "
                          validation-field-name="بودجه کل"
                          label="بودجه کل"
                        ></validation-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </tab-content>
      <tab-content :before-change="validateAsync" title="تصاویر">
        <ValidationObserver ref="step3" tag="div">
          <form class="needs-validation">
            <div class="row px-0">
              <div class="col-12 px-0">
                <div class="card px-0">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <validation-image-cropper-upload
                          rules="required"
                          validation-field-name="تصویر شماره 1"
                          label="تصویر شماره 1 (حداکثر 1280 * 1280)"
                          v-model="form.img1"
                        ></validation-image-cropper-upload>
                      </div>
                      <div class="col-12 col-md-6">
                        <validation-image-cropper-upload
                          rules="required"
                          validation-field-name="تصویر شماره 2"
                          label="تصویر شماره 2 (حداکثر 1280 * 1280)"
                          v-model="form.img2"
                        ></validation-image-cropper-upload>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <validation-image-cropper-upload
                          rules="required"
                          validation-field-name="تصویر شماره 3"
                          label="تصویر شماره 3 (حداکثر 1280 * 1280)"
                          v-model="form.img3"
                        ></validation-image-cropper-upload>
                      </div>
                      <div class="col-12 col-md-6">
                        <validation-image-cropper-upload
                          rules="required"
                          validation-field-name="تصویر شماره 4"
                          label="تصویر شماره 4 (حداکثر 1280 * 1280)"
                          v-model="form.img4"
                        ></validation-image-cropper-upload>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <validation-image-cropper-upload
                          rules="required"
                          validation-field-name="تصویر share pic"
                          label="تصویر share pic (حداکثر 1280 * 1280)"
                          v-model="form.sharePic"
                        ></validation-image-cropper-upload>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </tab-content>
      <tab-content :before-change="validateAsync" title="ویدئو">
        <ValidationObserver ref="step4" tag="div">
          <form class="needs-validation">
            <div class="row px-0">
              <div class="col-12 px-0">
                <div class="card px-0">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                        <validation-file-upload
                          rules="required"
                          validation-field-name="ویدئو"
                          label="ویدئو"
                          v-model="form.vidAdd"
                          accepted-files="video/*"
                          file-type="video"
                          :options="{ maxFilesize: 20 }"
                        >
                        </validation-file-upload>
                        <video
                          :src="
                            `${form.vidAdd}?v=${form.vidAdd
                              .split('')
                              .sort(function() {
                                return 0.5 - Math.random();
                              })
                              .join('')}`
                          "
                          class="mt-4"
                          v-if="form.vidAdd !== ''"
                          style="width: 100%"
                          controls
                        ></video>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </tab-content>
      <tab-content :before-change="validateAsync" title="لینک فرود">
        <ValidationObserver ref="step5" tag="div">
          <form class="needs-validation">
            <div class="row px-0">
              <div class="col-12 px-0">
                <div class="card px-0">
                  <div class="card-body">
                    <div class="row w-100">
                      <b-tabs
                        class="w-100"
                        justified
                        nav-class="nav-tabs-custom"
                        content-class="p-3 text-muted"
                      >
                        <b-tab active>
                          <h6 class="text-danger">
                            از این قسمت می توانید مشخص کنید که وقتی در موبایل
                            های اندروید بر روی تبلیغ کلیک شد چه اتفاقی روی دهد
                          </h6>
                          <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                              <i class="fas fa-home"></i>
                            </span>
                            <span class="d-none d-sm-inline-block"
                              >پلتفرم اندروید</span
                            >
                          </template>
                          <validation-select
                            class="mt-4"
                            :options="androidPlatformOptions"
                            v-model="selectedAndroidPlatform"
                            validation-field-name="نوع رویداد"
                            option-value-key="id"
                            option-text-key="name"
                            label="نوع رویداد"
                          >
                          </validation-select>
                          <div class="row">
                            <div
                              class="col-12"
                              v-if="selectedAndroidPlatform.id === 1"
                            >
                              <validation-input
                                v-model="form.cafebazarLinkAnd"
                                type="text"
                                rules="regex:^[a-z][a-z0-9_]*(\.[a-z0-9_]+)+[0-9a-z_]$"
                                placeholder="نام پکیج برنامه در کافه بازار"
                                validation-field-name="نام پکیج برنامه در کافه بازار"
                                label="نام پکیج برنامه در کافه بازار"
                              ></validation-input>
                            </div>
                            <div
                              class="col-12"
                              v-if="selectedAndroidPlatform.id === 2"
                            >
                              <validation-input
                                v-model="form.playstoreLinkAnd"
                                type="text"
                                rules="regex:^[a-z][a-z0-9_]*(\.[a-z0-9_]+)+[0-9a-z_]$"
                                placeholder="نام پکیج برنامه در پلی استور"
                                validation-field-name="نام پکیج برنامه در پلی استور"
                                label="نام پکیج برنامه در پلی استور"
                              ></validation-input>
                            </div>
                          </div>
                          <div class="row">
                            <div
                              class="col-12"
                              v-if="selectedAndroidPlatform.id === 3"
                            >
                              <validation-input
                                v-model="form.intentAnd"
                                type="text"
                                placeholder="نام Intent"
                                validation-field-name="نام Intent"
                                label="نام Intent"
                              ></validation-input>
                            </div>
                            <div
                              class="col-12"
                              v-if="selectedAndroidPlatform.id === 4"
                            >
                              <validation-input
                                v-model="form.linkAnd"
                                type="text"
                                rules="url"
                                placeholder="آدرس سایت"
                                validation-field-name="آدرس سایت"
                                label="آدرس سایت"
                              ></validation-input>
                            </div>
                          </div>
                          <div class="row">
                            <div
                              class="col-12"
                              v-if="selectedAndroidPlatform.id === 5"
                            >
                              <validation-input
                                v-model="form.phonenoAnd"
                                type="tel"
                                rules="numeric"
                                placeholder="شماره تماس"
                                validation-field-name="شماره تماس"
                                label="تماس تلفنی"
                              ></validation-input>
                            </div>
                          </div>
                          <div class="row">
                            <div
                              class="col-md-12"
                              v-if="selectedAndroidPlatform.id === 6"
                            >
                              <validation-input
                                v-model="form.phonenoAnd"
                                type="tel"
                                rules="mobile|numeric"
                                placeholder="شماره پیامک"
                                validation-field-name="شماره پیامک"
                                label="شماره پیامک"
                              ></validation-input>
                            </div>
                            <div
                              class="col-md-12"
                              v-if="selectedAndroidPlatform.id === 6"
                            >
                              <validation-input
                                v-model="form.smsAnd"
                                type="text"
                                placeholder="متن پیامک"
                                validation-field-name="متن پیامک"
                                label="متن پیامک"
                              ></validation-input>
                            </div>
                          </div>
                        </b-tab>
                        <b-tab>
                          <h6 class="text-danger">
                            از این قسمت می توانید مشخص کنید که وقتی در موبایل
                            های IOS بر روی تبلیغ کلیک شد چه اتفاقی روی دهد
                          </h6>
                          <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                              <i class="fas fa-home"></i>
                            </span>
                            <span class="d-none d-sm-inline-block"
                              >پلتفرم IOS</span
                            >
                          </template>
                          <validation-select
                            class="mt-4"
                            :options="iosPlatformOptions"
                            v-model="selectedIosPlatform"
                            validation-field-name="نوع رویداد"
                            option-value-key="id"
                            option-text-key="name"
                            label="نوع رویداد"
                          >
                          </validation-select>
                          <div class="row">
                            <div
                              class="col-12"
                              v-if="selectedIosPlatform.id === 1"
                            >
                              <validation-input
                                v-model="form.appStoreIos"
                                type="text"
                                rules="regex:^[a-z][a-z0-9_]*(\.[a-z0-9_]+)+[0-9a-z_]$"
                                placeholder="نام پکیج برنامه در App store"
                                validation-field-name="نام پکیج برنامه در App store"
                                label="نام پکیج برنامه در App store"
                              ></validation-input>
                            </div>
                          </div>
                          <div class="row">
                            <div
                              class="col-12"
                              v-if="selectedIosPlatform.id === 2"
                            >
                              <validation-input
                                v-model="form.linkIos"
                                type="text"
                                rules="url"
                                placeholder="آدرس سایت"
                                validation-field-name="آدرس سایت"
                                label="آدرس سایت"
                              ></validation-input>
                            </div>
                          </div>
                          <div class="row">
                            <div
                              class="col-12"
                              v-if="selectedIosPlatform.id === 3"
                            >
                              <validation-input
                                v-model="form.phonenoIos"
                                type="tel"
                                rules="numeric"
                                placeholder="شماره تماس"
                                validation-field-name="شماره تماس"
                                label="تماس تلفنی"
                              ></validation-input>
                            </div>
                          </div>
                          <div class="row" v-if="selectedIosPlatform.id === 4">
                            <div class="col-md-12">
                              <validation-input
                                v-model="form.phonenoIos"
                                type="tel"
                                rules="mobile|numeric"
                                placeholder="شماره پیامک"
                                validation-field-name="شماره پیامک"
                                label="شماره پیامک"
                              ></validation-input>
                            </div>
                            <div class="col-md-12">
                              <validation-input
                                v-model="form.smsIos"
                                type="text"
                                placeholder="متن پیامک"
                                validation-field-name="متن پیامک"
                                label="متن پیامک"
                              ></validation-input>
                            </div>
                          </div>
                        </b-tab>
                        <b-tab>
                          <h6 class="text-danger">
                            از این قسمت می توانید مشخص کنید که وقتی در مرورگرهای
                            دسکتاپ بر روی تبلیغ کلیک شد چه اتفاقی روی دهد
                          </h6>
                          <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                              <i class="fas fa-home"></i>
                            </span>
                            <span class="d-none d-sm-inline-block"
                              >وب دسکتاپ</span
                            >
                          </template>
                          <div class="col-12">
                            <validation-input
                              v-model="form.linkWeb"
                              type="text"
                              placeholder="آدرس اینترنتی"
                              validation-field-name="آدرس اینترنتی"
                              label="آدرس اینترنتی"
                            ></validation-input>
                          </div>
                        </b-tab>
                        <b-tab>
                          <h6 class="text-danger">
                            از این قسمت می توانید مشخص کنید که وقتی در مرورگرهای
                            موبایل بر روی تبلیغ کلیک شد چه اتفاقی روی دهد
                          </h6>
                          <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                              <i class="fas fa-home"></i>
                            </span>
                            <span class="d-none d-sm-inline-block"
                              >موبایل وب</span
                            >
                          </template>
                          <validation-select
                            class="mt-4"
                            :options="mobileWebPlatformOptions"
                            v-model="selectedMobileWebPlatform"
                            validation-field-name="نوع رویداد"
                            option-value-key="id"
                            option-text-key="name"
                            label="نوع رویداد"
                          >
                          </validation-select>
                          <div class="row">
                            <div
                              class="col-12"
                              v-if="selectedMobileWebPlatform.id === 3"
                            >
                              <validation-input
                                v-model="form.linkMobWeb"
                                type="text"
                                rules="url"
                                placeholder="آدرس سایت"
                                validation-field-name="آدرس سایت"
                                label="آدرس سایت"
                              ></validation-input>
                            </div>
                          </div>
                        </b-tab>
                      </b-tabs>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </tab-content>
      <tab-content :before-change="validateAsync" title="فیلترها">
        <ValidationObserver ref="step6" tag="div">
          <form class="needs-validation">
            <div class="row px-0">
              <div class="col-12 px-0">
                <div class="card px-0">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <validation-select
                          v-model="form.locations"
                          :options="locationOptions"
                          placeholder="محدوده جغرافیایی"
                          option-value-key="id"
                          option-text-key="nameFa"
                          multiple
                          validation-field-name="محدوده جغرافیایی"
                          label="محدوده جغرافیایی"
                        ></validation-select>
                      </div>
                      <div class="col-md-6">
                        <validation-select
                          v-model="form.netProviders"
                          type="text"
                          placeholder="تأمین کنندگان اینترنت"
                          :options="netProviderOptions"
                          multiple
                          option-value-key="id"
                          option-text-key="nameFa"
                          validation-field-name="تأمین کنندگان اینترنت"
                          label="تأمین کنندگان اینترنت"
                        ></validation-select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <validation-select
                          v-model="form.mobileBrands"
                          :options="mobileBrandOptions"
                          placeholder="برند گوشی"
                          option-value-key="id"
                          option-text-key="nameFa"
                          multiple
                          validation-field-name="برند گوشی"
                          label="برند گوشی"
                        ></validation-select>
                      </div>
                      <div class="col-md-6">
                        <validation-select
                          v-model="form.operators"
                          type="text"
                          placeholder="اپراتورهای سیمکارت"
                          :options="operatorOptions"
                          multiple
                          option-value-key="id"
                          option-text-key="nameFa"
                          validation-field-name="اپراتورهای سیمکارت"
                          label="اپراتورهای سیمکارت"
                        ></validation-select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </tab-content>
      <tab-content :before-change="validateAsync" title="قالب نمایش تبلیغ">
        <ValidationObserver ref="step7" tag="div">
          <form class="needs-validation">
            <div class="row px-0">
              <div class="col-12 px-0">
                <div class="card px-0">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12 d-flex flex-column col-md-4">
                        <div
                          class="d-flex flex-row align-items-center justify-content-start"
                          style="height: 150px"
                        >
                          <div class="col-6 h-100 bg-light"></div>
                          <div class="col-6 h-100">
                            <div
                              class="col-12 bg-light"
                              style="height: 70px;float: top"
                            ></div>
                            <div
                              class="col-12 bg-light"
                              style="height: 30px;float: bottom;margin-top: 50px"
                            ></div>
                          </div>
                        </div>
                        <input
                          type="radio"
                          value="1"
                          class="mt-4 mx-auto"
                          v-model="form.ghalebId"
                        />
                      </div>
                      <div class="col-12 d-flex flex-column col-md-4">
                        <div
                          class="d-flex flex-row align-items-center justify-content-start"
                          style="height: 150px"
                        >
                          <div class="col-6 h-100">
                            <div
                              class="col-12 bg-light"
                              style="height: 70px;float: top"
                            ></div>
                            <div
                              class="col-12 bg-light"
                              style="height: 30px;float: bottom;margin-top: 50px"
                            ></div>
                          </div>
                          <div class="col-6 h-100 bg-light"></div>
                        </div>
                        <input
                          type="radio"
                          value="2"
                          class="mt-4 mx-auto"
                          v-model="form.ghalebId"
                        />
                      </div>
                      <div class="col-12 d-flex flex-column col-md-4">
                        <div
                          class="d-flex flex-row align-items-center justify-content-start"
                          style="height: 150px"
                        >
                          <div class="col-6 h-100">
                            <div class="w-100" style="float:top;height: 65px">
                              <div
                                class="bg-light col-5 h-100"
                                style="float: right"
                              ></div>
                              <div
                                class="bg-light col-5 h-100"
                                style="float: left"
                              ></div>
                            </div>
                            <div
                              class="w-100"
                              style="margin-top: 20px;float: bottom;height: 65px"
                            >
                              <div
                                class="bg-light col-5 h-100"
                                style="float: right"
                              ></div>
                              <div
                                class="bg-light col-5 h-100"
                                style="float: left"
                              ></div>
                            </div>
                          </div>
                          <div class="col-6 h-100">
                            <div
                              class="col-12 bg-light"
                              style="height: 70px;float: top"
                            ></div>
                            <div
                              class="col-12 bg-light"
                              style="height: 30px;float: bottom;margin-top: 50px"
                            ></div>
                          </div>
                        </div>
                        <input
                          type="radio"
                          value="3"
                          class="mt-4 mx-auto"
                          v-model="form.ghalebId"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </tab-content>
      <tab-content :before-change="validateAsync" title="زمان بندی نمایش">
        <ValidationObserver ref="step8" tag="div">
          <form class="needs-validation">
            <div class="row px-0">
              <div class="col-12 px-0">
                <div class="card px-0">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <validation-time
                          rules="required"
                          label="زمان شروع نمایش تبلیغ"
                          validation-field-name="زمان شروع نمایش تبلیغ"
                          v-model="form.startShowTime"
                        >
                        </validation-time>
                      </div>
                      <div class="col-md-6">
                        <validation-time
                          rules="required"
                          label="زمان پایان نمایش تبلیغ"
                          validation-field-name="زمان پایان نمایش تبلیغ"
                          v-model="form.endShowTime"
                        >
                        </validation-time>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import ValidationRangeSlider from "@/components/ValidationFormInputs/ValidationRangeSlider";
import ValidationTime from "@/components/ValidationFormInputs/ValidationTime";

export default {
  props: {
    id: {
      type: [Number, String, null],
      required: false,
    },
  },
  components: {
    FormWizard,
    TabContent,
    ValidationRangeSlider,
    ValidationTime,
  },
  data() {
    return {
      crudeForm: {
        name: "",
        picAdd: "",
        description: "",
        btnText: "",
        hazine: 50,
        img1: "",
        img2: "",
        img3: "",
        img4: "",
        sharePic: "",
        ghalebId: 1,
        vidAdd: "",
        operators: [],
        netProviders: [],
        locations: [],
        mobileBrands: [],
        minAndroid: "",
        maxAndroid: "",
        startShowTime: "",
        endShowTime: "",
        dailybudget: "",
        totalBudget: "",
        cafebazarLinkAnd: "",
        playstoreLinkAnd: "",
        intentAnd: "",
        linkAnd: "",
        phonenoAnd: "",
        smsAnd: "",
        appStoreIos: "",
        linkIos: "",
        phonenoIos: "",
        smsIos: "",
        linkWeb: "",
        linkMobWeb: "",
        androidVersionName: [],
        tablighKindId: 1,
        justMine: 0,
        canSkip: 0,
        androidPkgName: "",
        iosPkgName: "",
      },
      form: this.crudeForm,
      rerenderComponent: false,
      currentStep: 0,
      categoryOptions: [],
      operatorOptions: [],
      netProviderOptions: [],
      locationOptions: [],
      mobileBrandOptions: [],
      kindOptions: [],
      campaign_min_total_budget: "",
      androidPlatformOptions: [
        {
          name: "باز کردن کافه بازار",
          id: 1,
        },
        {
          name: "باز کردن پلی استور",
          id: 2,
        },
        {
          name: "باز کردن Intent",
          id: 3,
        },
        {
          name: "بازکردن وبسایت",
          id: 4,
        },
        {
          name: "تماس تلفنی",
          id: 5,
        },
        {
          name: "ارسال پیامک",
          id: 6,
        },
      ],
      selectedAndroidPlatform: {
        name: "باز کردن کافه بازار",
        id: 1,
      },
      iosPlatformOptions: [
        {
          name: "باز کردن App store",
          id: 1,
        },
        {
          name: "باز کردن آدرس اینترنتی",
          id: 2,
        },
        {
          name: "تماس تلفنی",
          id: 3,
        },
        {
          name: "ارسال پیامک",
          id: 4,
        },
      ],
      selectedIosPlatform: {
        name: "باز کردن App store",
        id: 1,
      },
      mobileWebPlatformOptions: [
        {
          name: "مطابق با اندروید",
          id: 1,
        },
        {
          name: "مطابق با IOS",
          id: 2,
        },
        {
          name: "لینک دلخواه",
          id: 3,
        },
      ],
      selectedMobileWebPlatform: {
        name: "مطابق با اندروید",
        id: 1,
      },
      versionNames: [],
    };
  },
  computed: {
    isEditing() {
      return this.id != undefined && this.id != null;
    },
    title() {
      return this.isEditing ? "ویرایش کمپین" : "ثبت کمپین جدید";
    },
  },
  watch: {
    "$route.fullPath": {
      immediate: true, // Immediate option to call watch handler on first mount
      handler() {
        this.resetForm();
      },
    },
  },
  mounted() {
    this.fetchCampaignMetaData();
  },
  methods: {
    fetchCampaignMetaData() {
      this.$axios
        .get(`campaigns/meta-data`)
        .then((res) => {
          this.netProviderOptions = res.data.net_providers;
          this.locationOptions = res.data.locations;
          this.mobileBrandOptions = res.data.mobile_brands;
          this.operatorOptions = res.data.operators;
          this.kindOptions = res.data.kinds;
          this.versionNames = res.data.android_api_levels;
          this.form.androidVersionName.push(this.versionNames[0]);
          this.form.androidVersionName.push(
            this.versionNames[this.versionNames.length - 1]
          );
          this.campaign_min_total_budget = res.data.campaign_min_total_budget;
          if (this.isEditing) {
            this.fetchRecord();
          }
        })
        .catch((er) => {
          if (er.response.status === 404) {
            this.isRecordNotFound = true;
          }
        });
    },
    fetchRecord() {
      this.$axios.get(`campaigns/${this.id}`).then((res) => {
        this.form = { ...this.form, ...res.data };
        const app = this;
        this.form.androidVersionName = [
          this.form.minAndroid,
          this.form.maxAndroid,
        ];
        this.form.startShowTime =
          this.form.startShowTime.toString().substring(0, 2) +
          ":" +
          this.form.startShowTime.toString().substring(2, 4);
        this.form.endShowTime =
          this.form.endShowTime.toString().substring(0, 2) +
          ":" +
          this.form.endShowTime.toString().substring(2, 4);
        this.form.netProviders = this.form.net_providers;
        this.form.mobileBrands = this.form.mobile_brands;
        this.form.cafebazarLinkAnd = this.form.cafebazarLinkAnd.replace(
          "https://cafebazaar.ir/app/",
          ""
        );
        this.form.playstoreLinkAnd = this.form.playstoreLinkAnd.replace(
          "https://play.google.com/store/apps/details?id=",
          ""
        );
        const androidPlatformValues = [
          "cafebazarLinkAnd",
          "playstoreLinkAnd",
          "intentAnd",
          "linkAnd",
          "phonenoAnd",
          "smsAnd",
        ];

        androidPlatformValues.forEach((element, index) => {
          if (index === "smsAnd") {
            if (element !== "") {
              this.selectedAndroidPlatform = this.androidPlatformOptions.find(
                (x) => x.id === index + 1
              );
            }
          } else {
            console.log(this.form[element]);
            if (this.form[element] !== "") {
              this.selectedAndroidPlatform = this.androidPlatformOptions.find(
                (x) => x.id === index + 1
              );
            }
          }
        });

        const iosPlatformValues = [
          "appStoreIos",
          "linkIos",
          "phonenoIos",
          "smsIos",
        ];
        iosPlatformValues.forEach((element, index) => {
          if (index === "smsIos") {
            if (element !== "") {
              this.selectedIosPlatform = this.androidPlatformOptions.find(
                (x) => x.id === index + 1
              );
            }
          } else {
            if (this.form[element] !== "") {
              this.selectedIosPlatform = this.iosPlatformOptions.find(
                (x) => x.id === index + 1
              );
            }
          }
        });

        if (
          app.selectedAndroidPlatform.id === 4 &&
          this.form.linkMobWeb === this.form.linkAnd
        ) {
          app.selectedMobileWebPlatform = app.mobileWebPlatformOptions.find(
            (x) => x.id === 1
          );
        } else {
          if (
            app.selectedIosPlatform.id === 2 &&
            this.form.linkMobWeb === this.form.linkIos
          ) {
            console.log(app.mobileWebPlatformOptions.find((x) => x.id === 2));
            app.selectedMobileWebPlatform = app.mobileWebPlatformOptions.find(
              (x) => x.id === 2
            );
          } else {
            app.selectedMobileWebPlatform = app.mobileWebPlatformOptions.find(
              (x) => x.id === 3
            );
          }
        }
        this.form.tablighKindId = this.kindOptions.find(
          (x) => x.id === app.form.tablighKindId
        );

        this.rerenderComponent = true;
      });
    },
    submitForm() {
      const data = JSON.parse(JSON.stringify(this.form));
      data.tablighKindId = data.tablighKindId.id;

      if (typeof data.justMine === "boolean") {
        data.justMine = data.justMine === true ? 1 : 0;
      }

      if (typeof data.canSkip === "boolean") {
        data.canSkip = data.canSkip === true ? 1 : 0;
      }

      const operators = [];
      data.operators.forEach((item) => {
        operators.push(item.id);
      });
      data.operators = operators;

      const netProviders = [];
      data.netProviders.forEach((item) => {
        netProviders.push(item.id);
      });
      data.net_providers = netProviders;

      const locations = [];
      data.locations.forEach((item) => {
        locations.push(item.id);
      });
      data.locations = locations;

      const mobileBrands = [];
      data.mobileBrands.forEach((item) => {
        mobileBrands.push(item.id);
      });
      data.mobile_brands = mobileBrands;

      data.minAndroid = data.androidVersionName[0];
      data.maxAndroid = data.androidVersionName[1];

      switch (this.selectedAndroidPlatform.id) {
        case 1:
          data.cafebazarLinkAnd =
            "https://cafebazaar.ir/app/" + data.cafebazarLinkAnd;
          data.playstoreLinkAnd = data.intentAnd = data.linkAnd = data.phonenoAnd = data.smsAnd =
            "";
          break;
        case 2:
          data.playstoreLinkAnd =
            "https://play.google.com/store/apps/details?id=" +
            data.playstoreLinkAnd;
          data.cafebazarLinkAnd = data.intentAnd = data.linkAnd = data.phonenoAnd = data.smsAnd =
            "";
          break;
        case 3:
          data.cafebazarLinkAnd = data.playstoreLinkAnd = data.linkAnd = data.phonenoAnd = data.smsAnd =
            "";
          break;
        case 4:
          data.cafebazarLinkAnd = data.playstoreLinkAnd = data.intentAnd = data.phonenoAnd = data.smsAnd =
            "";
          break;
        case 5:
          data.cafebazarLinkAnd = data.playstoreLinkAnd = data.linkAnd = data.smsAnd = data.intentAnd =
            "";
          break;
        case 6:
          data.cafebazarLinkAnd = data.playstoreLinkAnd = data.linkAnd = data.intentAnd =
            "";
          break;
      }

      switch (this.selectedIosPlatform.id) {
        case 1:
          data.linkIos = data.phonenoIos = data.smsIos = "";
          break;
        case 2:
          data.appStoreIos = data.phonenoIos = data.smsIos = "";
          break;
        case 3:
          data.appStoreIos = data.linkIos = data.smsIos = "";
          break;
        case 4:
          data.appStoreIos = data.linkIos = "";
          break;
      }

      switch (this.selectedMobileWebPlatform.id) {
        case 1:
          data.linkMobWeb = data.linkAnd;
          break;
        case 2:
          data.linkMobWeb = data.linkIos;
          break;
      }

      data.startShowTime = data.startShowTime.replaceAll(":", "");
      data.endShowTime = data.endShowTime.replaceAll(":", "");

      if (this.isEditing) {
        this.updateRecord(data);
      } else {
        this.createRecord(data);
      }
    },
    createRecord(data) {
      this.$axios.post("campaigns", data).then((res) => {
        this.$swal("موفق!", "کمپین با موفقیت به ثبت شد", "success");
        this.$store.dispatch("tables/addNewItem", {
          key: "campaigns",
          item: res.data,
        });
      });
    },
    updateRecord(data) {
      this.$axios.put(`campaigns/${this.id}`, data).then(() => {
        this.$swal("موفق!", "کمپین با موفقیت به روزرسانی شد", "success");
        this.$store.dispatch("tables/updateItem", {
          key: "campaigns",
          item: this.form,
        });
      });
    },
    resetForm() {
      this.rerenderComponent = false;
      this.$nextTick(() => {
        this.form = this.crudeForm;
        this.rerenderComponent = true;
      });
    },
    async validateAsync() {
      const valid = await this.$refs[`step${this.currentStep}`].validate();
      return new Promise((resolve, reject) => {
        if (valid) {
          resolve(true);
        } else {
          this.$swal.fire(
            "خطا!",
            `در مرحله ${this.currentStep + 1} خطایی روی داده است`,
            "error"
          );
          reject();
        }
      });
    },
    handleChangeStep(prevIndex, nextIndex) {
      this.currentStep = nextIndex;
    },
  },
};
</script>
